<template>
  <div class='main-container cursor-pointer' :style='`background: ${color || colors[title.toUpperCase()]}`' @click="loadGrid()">
    <div style="display:none;"> {{ delay }} </div>
    <div class="header"><h4 :style='`font-size: ${font || ""}`'>{{ title }}</h4> <h4 style='font-size: 22px'> {{ perc }} <span v-if='perc || perc == 0'>%</span></h4></div>
    <div class="content">{{ content }}</div>
    <div class="footer-text"> {{ $t("161") }}</div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

export default {
  props: {
    title: {
      type: String
    },
    perc:{
      type: Number
    },
    content: {
      type: Number
    },
    color: {
      type: String
    },
    font: {
      type: String
    },
    delay: {
      type: Number
    }
  },
  data() {
    return {
      colors: {
        'R0': '#e4d354',
        'R1': '#f2c946',
        'R2': '#f0893a',
        'R3': '#f45b5b',
        'R3+': '#f45b5b'
      },
    }
  },
  mixins: [mixin],
  methods: {
    ...mapMutations(['changeGrid']),

    loadGrid(event){

      if(this.content != 0){ 

        if(this.getTab == 'offline'){

          //console.log('title: ', this.title)

          let region = this.filters.region
          //console.log('region: ', region)

          let plant = this.filters.plant
          //console.log('plant: ', plant)             

          let status = this.title

          
          let feedback_status;
          let delay;

          if(!this.delay){
            delay = ''
            feedback_status = ''
          }
          if(this.delay == 0 || this.delay == 1 || this.delay == 2 || this.delay == 3){
            delay = this.delay
            feedback_status = 'CLOSED'
          }

          let NAME_CHART = this.$t("376") + ' - ' + this.title.toUpperCase()

          const ENDPOINT = `v1/mysemeq-ambev/get-reports-repetition?plant=${plant}&region=${region}&status=${status}&technique=${this.filters.technique}&year=${this.filters.year}&period=${this.filters.period}&area=${this.filters.area}&sector=${this.filters.sector}&machine=${this.filters.machine}&component=${this.filters.component}&feedback_status=${feedback_status}&delay=${delay}&online=0`

          let grid = {
            totalDados: this.content,
            title: this.title,
            url: ENDPOINT,
            name_chart: NAME_CHART,
            columns: {
                    "rows": '',
                    "plant": this.$t("310"),
                    "area": this.$t("311"),
                    "sector": this.$t("312"),
                    "component": this.$t("313"),
                    "component_tag": this.$t("314"),
                    "component_type_en": this.$t("315"),
                    "machine": this.$t("316"),
                    "machine_tag": this.$t("317"),
                    "technique_en": this.$t("321"),
                    "report_number": this.$t("319"), 
                    "approved_datetime": this.$t("320"),
                    "link": this.$t("323"),
                    "link_rci": this.$t("324"),
                    "pending_days": this.$t("325"),
                    "delay": this.$t("326"),
                    "prescription_created_datePtime": this.$t("327"), 
                    "week": this.$t("328"),
                
                },
                show: true,
                titleHelp: 'Grid - ' + this.$t("356"),
                txtHelp: this.$t("357")
            }

          if (this.filters.plant) {
              grid.title += ' - ' + this.filters.plant_name
              delete grid.columns['plant']
          } else if (this.filters.region){
              grid.title += ' - ' + this.filters.region
          }

          // console.log(grid);

          this.changeGrid(grid);

        } //fim if offline

        if(this.getTab == 'online'){


          //console.log('getTab: ', this.getTab)
          //console.log('title: ', this.title)

          let region = this.filtersOn.region
          //console.log('region: ', region)

          let plant = this.filtersOn.planta
          //console.log('planta: ', plant)             

          let status = this.title

          let feedback_status;
          let delay;

          if(!this.delay){
            delay = ''
            feedback_status = ''
          }
          if(this.delay == 0 || this.delay == 1 || this.delay == 2 || this.delay == 3){
            delay = this.delay
            feedback_status = 'CLOSED'
          }

          let NAME_CHART = this.$t("376") + ' - ' + this.title.toUpperCase()

          const ENDPOINT = `v1/mysemeq-ambev/get-reports-repetition?plant=${plant}&region=${region}&status=${status}&technique=&year=${this.filtersOn.year}&period=${this.filtersOn.period}&area=${this.filtersOn.area_f}&sector=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&component=${this.filtersOn.subset}&feedback_status=${feedback_status}&delay=${delay}&online=1`

          let grid = {
            totalDados: this.content,
            title: this.title,
            url: ENDPOINT,
            name_chart: NAME_CHART,
            columns: {
                    "rows": '',
                    "plant": this.$t("310"),
                    "area": this.$t("311"),
                    "sector": this.$t("312"),
                    "component": this.$t("313"),
                    "component_tag": this.$t("314"),
                    "component_type_en": this.$t("315"),
                    "machine": this.$t("316"),
                    "machine_tag": this.$t("317"),
                    "technique_en": this.$t("321"),
                    "report_number": this.$t("319"), 
                    "approved_datetime": this.$t("320"),
                    "link": this.$t("323"),
                    "link_rci": this.$t("324"),
                    "pending_days": this.$t("325"),
                    "delay": this.$t("326"),
                    "prescription_created_datePtime": this.$t("327"), 
                    "week": this.$t("328"),
                },
                show: true,
                titleHelp: 'Grid - ' + this.$t("356"),
                txtHelp: this.$t("357")
            }

          if (this.filtersOn.planta) {
              grid.title += ' - ' + this.filtersOn.planta_name
              delete grid.columns['plant']
          } else if (this.filtersOn.region){
              grid.title += ' - ' + this.filtersOn.region
          }

          // console.log(grid);

          this.changeGrid(grid);


        }//fim if online
      }  

        

    },

  },
  computed: {
    ...mapGetters(['filters','filtersOn', 'getTab']),
  },
}
</script>

<style scoped>

.main-container {
  height: 140px;
  color: white;
  font-weight: 500;
  border: 1px solid #1E1E1E;
  text-shadow: -1px 1px 4px #1E1E1E;
}

.header {
  padding: 2px 15px 2px 15px;
}

.header h4 {
  font-size: 26px;
  margin: 0;
}

.header h4:first-child { float: left; }

.header h4:last-child{ float: right; }

.content{
  font-weight: 1000;
  font-size: 46px;
  text-align: center;
  margin-top: 30px;
  text-shadow: 1px 1px 1px #1E1E1E;
}

.footer-text {
  font-size: 26px;
  position: absolute !important;
  bottom: 10px !important;
  right: 30px !important;
}

.cursor-pointer{
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Components/ReincidenciaIndicator.vue